import { render, staticRenderFns } from "./ValidateBidBond.vue?vue&type=template&id=55ef624e"
import script from "./ValidateBidBond.vue?vue&type=script&lang=js"
export * from "./ValidateBidBond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports